var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOw2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1198_299)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.44585 4.95124C6.10925 4.28763 6.89683 3.76122 7.76363 3.40207C8.63043 3.04292 9.55947 2.85807 10.4977 2.85807C11.4359 2.85807 12.365 3.04292 13.2318 3.40207C14.0985 3.76122 14.8861 4.28763 15.5495 4.95124L17.5679 2.93241C16.6392 2.00277 15.5364 1.2653 14.3227 0.762139C13.1089 0.25898 11.8079 0 10.494 0C9.18014 0 7.87914 0.25898 6.66537 0.762139C5.4516 1.2653 4.34885 2.00277 3.42017 2.93241L5.44585 4.95124Z",
    fill: "#ED6516"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.156 3.56836L16.1239 5.60462C17.0145 6.74373 17.5388 8.12617 17.6278 9.56951C17.7167 11.0128 17.366 12.4492 16.622 13.6891L12.944 10.0093L10.9404 5.29629H10.9303V11.6611L14.9 15.6318C13.6429 16.6157 12.0926 17.1503 10.4963 17.1503C8.90008 17.1503 7.34979 16.6157 6.09267 15.6318L10.0651 11.6611V5.32015L8.05138 10.0093L4.37248 13.6891C3.62836 12.4492 3.27769 11.0127 3.3668 9.56934C3.4559 8.12595 3.98059 6.74353 4.87157 5.60462L2.83946 3.56836C1.61591 5.02692 0.833979 6.80448 0.585541 8.69218C0.337103 10.5799 0.63248 12.4993 1.43696 14.2249C2.24145 15.9505 3.52161 17.4106 5.12704 18.4336C6.73248 19.4566 8.59647 20 10.5 20C12.4035 20 14.2675 19.4566 15.873 18.4336C17.4784 17.4106 18.7586 15.9505 19.5631 14.2249C20.3675 12.4993 20.6629 10.5799 20.4145 8.69218C20.166 6.80448 19.3841 5.02692 18.1606 3.56836H18.156Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1198_299"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOw2);
export default __webpack_public_path__ + "static/media/ow2.efae95e97db9a6b4f740b33187b31dcf.svg";
export { ForwardRef as ReactComponent };